const WorkInProgressComponent = () =>
  import('@/views/wip/WorkInProgressComponent')

export const noteRootPages = {
  path: '/note',
  name: 'note_index_route',
  component: WorkInProgressComponent
}
